import React from 'react';
import { RoiCategoriesConfigSection } from '../uis/RoiCategoriesConfigSection';
import styles from '../ProjectEditForm.module.css';

/**
 * Project-level ROI types and enablement (stored on annotationUI.config.roi).
 * Nested under the Images macro; omitted when the selected UI does not support ROI.
 */
function RoiSettingsPanel({
    supportsRoi,
    annotationUI,
    setAnnotationUI,
    projectChrome,
    settingsLocked = false,
}) {
    const roi = annotationUI?.config?.roi ?? { enabled: false, roiCategories: [] };

    if (!supportsRoi) {
        return null;
    }

    return (
        <div className={styles.panel}>
            <h4 className={styles.panelTitle}>Regions of interest</h4>
            {settingsLocked && (
                <p className={styles.panelLockBanner}>
                    Published: return to draft to edit this section.
                </p>
            )}
            <div className={settingsLocked ? styles.panelDisabled : undefined}>
                <RoiCategoriesConfigSection
                    roi={roi}
                    showIntro={false}
                    onRoiChange={(nextRoi) => {
                        setAnnotationUI((prev) => ({
                            ...prev,
                            config: { ...(prev.config ?? {}), roi: nextRoi },
                        }));
                    }}
                    roiEditorChrome={projectChrome}
                />
            </div>
        </div>
    );
}

export default React.memo(RoiSettingsPanel);
